import getPaymentProviders from './get-payment-providers';
import get from 'lodash.get';

const isOnlinePaymentAvailable = (order) => {
  const payments = get(order, 'company.order_settings.payments', {});
  return !!getPaymentProviders(payments).length;
};

export default isOnlinePaymentAvailable;
